import Instance from "../../../../Axios";

// New Actions for the app

const GetCredCopiaCredenciacao = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/copiaCredenciacao`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_COPIA_CRECENCIACAO",
        payload: data.yData[0],
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredCopiaCredenciacao;
